const ChatClientChannelConnectionStatus = {
  pending: 'pending',
  connecting: 'connecting',
  connected: 'connected',
  connectionError: 'connectionError',
};

export default ChatClientChannelConnectionStatus;
